import { useState } from 'react';
import type { CancelScheduledPaymentResponse, ScheduledTransactionsList } from 'vopay';
import { api } from '@/services/api.config';
import { useDataFetchIndicator } from '..';

export default function useCancelScheduledTransaction() {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [cancelling, setCancelling] = useState(false);

  async function cancelScheduledTransaction(
    transaction: ScheduledTransactionsList,
  ): Promise<CancelScheduledPaymentResponse> {
    try {
      setCancelling(true);
      setDataFetchingInfo(true, 'processing', 'fullScreen');

      // Records in the new VIOScheduledPayments table expose a top-level
      // TransactionType and are the only ones the universal endpoint can cancel
      // Legacy VIOEFTScheduledPayments records have no TransactionType and must use the EFT-specific endpoints,
      // since /scheduled-payment/cancel cannot reach the legacy table. Note the
      // new endpoint keys off ScheduledPaymentsID while the legacy ones use
      // ScheduledTransactionID.
      let res: CancelScheduledPaymentResponse;
      if (transaction.TransactionType) {
        res = await api.postCancelScheduledPayment({ ScheduledPaymentsID: transaction.ID });
      } else if (transaction.Type === 'fund') {
        res = await api.postCancelScheduledFund({ ScheduledTransactionID: transaction.ID });
      } else {
        res = await api.postCancelScheduledWithdraw({ ScheduledTransactionID: transaction.ID });
      }

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }
      return res;
    } catch (error) {
      console.error('Cancel scheduled transaction failed:', error);
      throw error;
    } finally {
      setCancelling(false);
      setDataFetchingInfo(false);
    }
  }

  return { cancelling, cancelScheduledTransaction };
}
